import { LockedPage } from "@/components/LockedPage";
import { Card } from "@/components/ui/card";
import { eur } from "@/lib/api";

const ROWS = [
  ["Farina 00 (kg)", "Molino Bianchi", 25, 0.9, "Da ordinare"],
  ["Mozzarella fiordilatte (kg)", "Caseificio Sud", 12, 7.4, "Da ordinare"],
  ["Pomodoro pelato (lt)", "Ortofrutta Verdi", 36, 1.2, "OK"],
  ["Gambero rosso (kg)", "Pescheria Mare", 6, 28.0, "Ordinato"],
  ["Birra bionda 40cl (pz)", "Beverage Srl", 96, 1.1, "OK"],
];

export default function Spesa() {
  return (
    <LockedPage
      title="Spesa e fornitori"
      description="Lista della spesa automatica dai consumi, ordini ai fornitori e costo materie prime."
      preview={
        <div className="space-y-4 p-6">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {[["Da ordinare", "7 articoli"], ["Spesa settimana", eur(2140)], ["Food cost", "28,4%"]].map(([l, v]) => (
              <Card key={l} className="p-5">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{l}</p>
                <p className="font-num mt-3 text-xl font-bold">{v}</p>
              </Card>
            ))}
          </div>
          <Card className="p-5">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-[10px] uppercase tracking-[0.16em] text-slate-500">
                  <th className="py-2 font-bold">Articolo</th>
                  <th className="py-2 font-bold">Fornitore</th>
                  <th className="py-2 font-bold">Quantità</th>
                  <th className="py-2 font-bold">Prezzo unit.</th>
                  <th className="py-2 font-bold">Stato</th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r) => (
                  <tr key={r[0]} className="border-b border-slate-100 last:border-0">
                    <td className="py-3 font-medium">{r[0]}</td>
                    <td className="py-3 text-slate-500">{r[1]}</td>
                    <td className="py-3 font-num">{r[2]}</td>
                    <td className="py-3 font-num">{eur(r[3])}</td>
                    <td className="py-3">{r[4]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </div>
      }
    />
  );
}
